/**
 * Generated by orval v8.0.0-rc.0 🍺
 * Do not edit manually.
 */
import * as zod from 'zod';


/**
 * @summary 管理员登录
 */
export const adminLoginBodyUsernameMin = 3;
export const adminLoginBodyUsernameMax = 50;

export const adminLoginBodyPasswordMin = 6;
export const adminLoginBodyPasswordMax = 32;



export const adminLoginBody = zod.object({
  "username": zod.string().min(adminLoginBodyUsernameMin).max(adminLoginBodyUsernameMax).describe('管理员用户名'),
  "password": zod.string().min(adminLoginBodyPasswordMin).max(adminLoginBodyPasswordMax).describe('登录密码'),
  "turnstileToken": zod.string().describe('Cloudflare Turnstile 验证码令牌')
})

export const adminLoginResponseTokenTypeDefault = "Bearer";

export const adminLoginResponse = zod.object({
  "accessToken": zod.string().optional().describe('访问令牌 (JWT)'),
  "refreshToken": zod.string().optional().describe('刷新令牌'),
  "tokenType": zod.string().default(adminLoginResponseTokenTypeDefault).describe('令牌类型'),
  "expiresIn": zod.number().optional().describe('访问令牌有效期（秒）'),
  "admin": zod.object({
  "id": zod.number().optional().describe('管理员用户 ID'),
  "deptId": zod.number().optional().describe('部门 ID'),
  "roleId": zod.number().optional().describe('主要角色 ID'),
  "roleIds": zod.array(zod.number()).optional().describe('所有角色 ID 列表'),
  "postIds": zod.array(zod.number()).optional().describe('岗位 ID 列表'),
  "username": zod.string().optional().describe('用户名'),
  "realName": zod.string().optional().describe('真实姓名'),
  "avatar": zod.string().optional().describe('头像 URL'),
  "sex": zod.number().optional().describe('性别 (1=男性, 2=女性, 0=未知)'),
  "telegram": zod.string().optional().describe('Telegram 账号'),
  "email": zod.string().optional().describe('邮箱地址'),
  "mobile": zod.string().optional().describe('手机号码'),
  "remark": zod.string().optional().describe('备注说明'),
  "status": zod.number().optional().describe('状态 (1=活跃, 0=禁用, -1=锁定)'),
  "isSuperAdmin": zod.boolean().optional().describe('是否为超级管理员'),
  "lastLoginAt": zod.number().optional().describe('最后登录时间（Unix 毫秒时间戳）'),
  "lastLoginIp": zod.string().optional().describe('最后登录 IP'),
  "lastActiveAt": zod.number().optional().describe('最后活跃时间（Unix 毫秒时间戳）'),
  "createdAt": zod.number().optional().describe('创建时间（Unix 毫秒时间戳）'),
  "deptName": zod.string().optional().describe('部门名称'),
  "roleName": zod.string().optional().describe('主要角色名称'),
  "permissions": zod.array(zod.string()).optional().describe('权限列表')
}).optional()
})

/**
 * @summary 管理员登出
 */
export const adminLogoutBody = zod.object({

})

export const adminLogoutResponse = zod.object({
  "success": zod.boolean().optional().describe('登出是否成功')
})

/**
 * @summary 修改密码
 */
export const adminUpdatePasswordBodyOldPasswordMin = 6;
export const adminUpdatePasswordBodyOldPasswordMax = 32;

export const adminUpdatePasswordBodyNewPasswordMin = 6;
export const adminUpdatePasswordBodyNewPasswordMax = 32;



export const adminUpdatePasswordBody = zod.object({
  "oldPassword": zod.string().min(adminUpdatePasswordBodyOldPasswordMin).max(adminUpdatePasswordBodyOldPasswordMax).describe('原密码'),
  "newPassword": zod.string().min(adminUpdatePasswordBodyNewPasswordMin).max(adminUpdatePasswordBodyNewPasswordMax).describe('新密码')
})

export const adminUpdatePasswordResponse = zod.object({

})

/**
 * @summary 获取当前管理员信息
 */
export const adminGetProfileResponse = zod.object({
  "id": zod.number().optional().describe('管理员用户 ID'),
  "deptId": zod.number().optional().describe('部门 ID'),
  "roleId": zod.number().optional().describe('主要角色 ID'),
  "roleIds": zod.array(zod.number()).optional().describe('所有角色 ID 列表'),
  "postIds": zod.array(zod.number()).optional().describe('岗位 ID 列表'),
  "username": zod.string().optional().describe('用户名'),
  "realName": zod.string().optional().describe('真实姓名'),
  "avatar": zod.string().optional().describe('头像 URL'),
  "sex": zod.number().optional().describe('性别 (1=男性, 2=女性, 0=未知)'),
  "telegram": zod.string().optional().describe('Telegram 账号'),
  "email": zod.string().optional().describe('邮箱地址'),
  "mobile": zod.string().optional().describe('手机号码'),
  "remark": zod.string().optional().describe('备注说明'),
  "status": zod.number().optional().describe('状态 (1=活跃, 0=禁用, -1=锁定)'),
  "isSuperAdmin": zod.boolean().optional().describe('是否为超级管理员'),
  "lastLoginAt": zod.number().optional().describe('最后登录时间（Unix 毫秒时间戳）'),
  "lastLoginIp": zod.string().optional().describe('最后登录 IP'),
  "lastActiveAt": zod.number().optional().describe('最后活跃时间（Unix 毫秒时间戳）'),
  "createdAt": zod.number().optional().describe('创建时间（Unix 毫秒时间戳）'),
  "deptName": zod.string().optional().describe('部门名称'),
  "roleName": zod.string().optional().describe('主要角色名称'),
  "permissions": zod.array(zod.string()).optional().describe('权限列表')
})

/**
 * @summary 刷新访问令牌
 */
export const adminTokenRefreshBody = zod.object({
  "refreshToken": zod.string().describe('刷新令牌')
})

export const adminTokenRefreshResponseTokenTypeDefault = "Bearer";

export const adminTokenRefreshResponse = zod.object({
  "accessToken": zod.string().optional().describe('新的访问令牌 (JWT)'),
  "refreshToken": zod.string().optional().describe('新的刷新令牌'),
  "tokenType": zod.string().default(adminTokenRefreshResponseTokenTypeDefault).describe('令牌类型'),
  "expiresIn": zod.number().optional().describe('访问令牌有效期（秒）')
})

